// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3RxL2","header":"Messages_header__M7aIC"};